import React from 'react'
import { useDispatch } from 'react-redux'
import { motion } from 'framer-motion'
import { Check } from 'lucide-react'
import { setTheme, setChatTheme } from 'store/actions/theme.action'

const ThemeList = ({ type, themesList, activeTheme, onClose }) => {
  const dispatch = useDispatch()

  const handleChange = (value) => {
    if (type === 'main') {
      dispatch(setTheme(value))
    } else {
      dispatch(setChatTheme(value))
    }
    onClose?.()
  }

  return (
    <div className="py-1 max-h-72 min-w-[130px] overflow-y-auto">
      {themesList.map(({ label, value }, i) => (
        <motion.div
          key={`theme-${i}`}
          className={`flex items-center cursor-pointer justify-between px-4 hover:bg-gray-50 dark:hover:bg-zinc-800/50 py-2 transition-colors duration-200 ${
            activeTheme === value ? 'bg-gray-50 dark:bg-zinc-800/50' : ''
          }`}
          onClick={() => handleChange(value)}
        >
          <div className="flex items-center gap-3">
            {type === 'chat' && (
              <div className="w-6 h-6 rounded-full overflow-hidden border border-gray-200 dark:border-zinc-700">
                <img className="w-full h-full object-cover" alt={label} src={`/assets/chat/${value}.png`} />
              </div>
            )}
            <span className={`text-sm text-zinc-900 dark:text-zinc-100 ${activeTheme === value ? 'font-medium' : ''}`}>
              {label}
            </span>
          </div>

          {activeTheme === value && <Check size={16} className="text-blue-600" />}
        </motion.div>
      ))}
    </div>
  )
}

export default ThemeList
